import { C_OUTLINE_VARIANT } from "./icon/Colors";
import { withStyles } from "@mui/styles";
import { Divider as MUIDivider } from "@mui/material";

export const Divider = withStyles({
  root: {
    backgroundColor: C_OUTLINE_VARIANT,
  },
})(MUIDivider);
